<template>
  <div>
    <b-card>
      <b-tabs
        content-class="mt-3"
        :vertical="window.width >= 768 ? false : true"
        nav-wrapper-class="w-100"
      >
        <b-tab title="جزییات درگاه" href="#gatewayDetail">
          <div>
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-alert variant="success" :show="success_errors.length > 0">
              <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-1"
                  label="تاریخ درخواست:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="Gateway.created_at"
                    disabled
                  ></b-form-input> </b-form-group
              ></b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-1"
                  label="تاریخ تایید درگاه:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="Gateway.mdid119_status_date"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-3"
                  label="کد API:"
                  label-for="input-3"
                >
                  <b-form-input
                    id="input-3"
                    v-model="Gateway.pin"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-1"
                  label="نام مالک درگاه:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="user_info.name"
                    required
                    readonly
                    placeholder="نام مالک درگاه"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-2"
                  label="شماره موبایل:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="user_info.mobile"
                    required
                    :readonly="
                      Gateway.mdid20_request_status == 1633 &&
                      Gateway.mdid19_status == 1581
                    "
                    placeholder="شماره موبایل"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-3"
                  label="ایمیل:"
                  label-for="input-3"
                >
                  <b-form-input
                    id="input-3"
                    v-model="user_info.email"
                    required
                    readonly
                    placeholder="ایمیل"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-1"
                  label="نام وبسایت:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="Gateway.website_name"
                    required
                    placeholder="نام وبسایت"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-2"
                  label="آدرس وبسایت:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.website"
                    required
                    placeholder="آدرس وبسایت"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-3"
                  label="نام انگلیسی وبسایت:"
                  label-for="input-3"
                >
                  <b-form-input
                    id="input-3"
                    v-model="Gateway.website_en_name"
                    required
                    placeholder="نام انگلیسی وبسایت"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-4"
                  label="توضیحات:"
                  label-for="input-4"
                >
                  <b-form-input
                    id="input-4"
                    v-model="Gateway.description"
                    required
                    placeholder="توضیحات"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-4"
                  label="شماره شبا:"
                  label-for="input-4"
                >
                  <b-form-select
                    id="input-4"
                    v-model="Gateway.user_card_id"
                    :options="optionsIban"
                    placeholder="شماره شبا"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-4"
                  label="تاریخ انقضا اینماد:"
                  label-for="input-4"
                >
                  <date-picker
                    v-model="Gateway.enamad_expiration"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-5"
                  label="گروه بندی:"
                  label-for="input-5"
                >
                  <MDDropdown
                    v-bind:group="9"
                    v-model="Gateway.mdid9_category"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-6"
                  label="نوع:"
                  label-for="input-6"
                >
                  <MDDropdown
                    v-bind:group="14"
                    v-model="Gateway.mdid14_direct_gate"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-7"
                  label="واحد پولی:"
                  label-for="input-7"
                >
                  <MDDropdown
                    v-bind:group="12"
                    v-model="Gateway.mdid12_money_type"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-form-group label="کد رهگیری:">
                  <b-input-group>
                    <div class="input-group-prepend">
                      <b-button @click="TaxInquiry()" variant="warning"
                        >استعلام کد رهگیری</b-button
                      >
                      <b-button @click="TaxRegister()" variant="danger"
                        >ثبت کد رهگیری</b-button
                      >
                    </div>

                    <b-form-input v-model="Gateway.taxpayercode"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-8"
                  label="دوره تسویه:"
                  label-for="input-8"
                >
                  <MDDropdown
                    v-bind:group="104"
                    v-model="Gateway.mdid104_payment_priority"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-form-group
                  id="input-group-18"
                  label="نوع اتصال به بانک:"
                  label-for="input-18"
                >
                  <b-form-select
                    :options="optionsConnect"
                    v-model="Gateway.is_direct"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="4"
                sm="6"
                v-if="Gateway.mdid104_payment_priority != 1658"
              >
                <b-form-group
                  id="input-group-8"
                  label="زمان تسویه:"
                  label-for="input-8"
                >
                  <MDDropdown
                    v-bind:group="105"
                    :parent="Gateway.mdid104_payment_priority"
                    v-model="Gateway.mdid105_payment_time"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4" sm="6" v-else></b-col>
              <b-col cols="12" md="4" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="آدرس Callback Url:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.callback_url"
                    placeholder="آدرس  Callback Url:"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6" sm="6">
                <b-form-group
                  id="input-group-5"
                  label="کد استان:"
                  label-for="input-5"
                  description="کد استان لطفا با 0 وارد شود"
                >
                  <b-form-input
                    id="input-4"
                    v-model="Gateway.pre_phone"
                    required
                    placeholder="کد استان"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" sm="6">
                <b-form-group
                  id="input-group-5"
                  label="تلفن ثابت:"
                  label-for="input-5"
                  description="تلفن باید بدون پیش کد وارد شود"
                >
                  <b-form-input
                    id="input-4"
                    v-model="Gateway.phone_support"
                    required
                    placeholder="تلفن ثابت"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="12">
                <b-form-checkbox
                  id="percent_price"
                  v-model="percent_price"
                  name="percent_price"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  درصدی از مبلغ تراکنش
                </b-form-checkbox>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="درصد کارمزد:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.pourcents_percent"
                    placeholder="درصد کارمزد"
                    :disabled="percent_price == 'not_accepted'"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="حداکثر مبلغ کارمزد:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.pourcents_percent_max_value"
                    placeholder="حداکثر مبلغ کارمزد"
                    :disabled="percent_price == 'not_accepted'"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" md="4" sm="6">
                <b-form-checkbox
                  id="fix_price"
                  v-model="fix_price"
                  name="fix_price"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  مبلغ ثابت
                </b-form-checkbox>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="مبلغ کارمزد ثابت:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.pourcents_value"
                    placeholder="مبلغ کارمزد ثابت"
                    :disabled="fix_price == 'not_accepted'"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="مبلغ سپرده:" label-for="input-deposit">
                  <b-form-input
                    id="input-deposit"
                    v-model="Gateway.min_sharing"
                    placeholder="مبلغ سپرده"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col cols="12" md="6" sm="6">
                <b-form-group
                  id="input-group-9"
                  label="وضعیت درخواست درگاه:"
                  label-for="input-9"
                >
                  <b-form-input
                    id="input-2"
                    disabled
                    v-model="Gateway.request_status.title"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col v-if="false" cols="12" md="6" sm="6">
                <div
                  v-if="
                    Gateway.mdid12_money_type == 483 ||
                    Gateway.mdid12_money_type == 484
                  "
                >
                  <div
                    v-if="
                      Gateway.request_status && Gateway.request_status.code == 0
                    "
                  >
                    <b-form-group
                      id="input-group-10"
                      label="عملیات:"
                      label-for="input-10"
                    >
                      <b-button
                        @click="SendRequestToBank()"
                        :disabled="disabled == 1"
                        >درخواست ثبت مشتری</b-button
                      >
                    </b-form-group>
                  </div>
                  <div
                    v-if="
                      Gateway.request_status && Gateway.request_status.code == 1
                    "
                  >
                    <b-form-group
                      id="input-group-10"
                      label="عملیات:"
                      label-for="input-10"
                    >
                      <b-button @click="GetResult()" :disabled="disabled == 1"
                        >دریافت نتیجه ثبت مشتری</b-button
                      >
                    </b-form-group>
                  </div>
                  <div
                    v-if="
                      Gateway.request_status && Gateway.request_status.code == 2
                    "
                  >
                    <b-form-group
                      id="input-group-10"
                      label="عملیات:"
                      label-for="input-10"
                    >
                      <b-button
                        @click="SendRequestToBank()"
                        :disabled="disabled == 1"
                        >درخواست درگاه</b-button
                      >
                    </b-form-group>
                  </div>
                  <div
                    v-if="
                      Gateway.request_status && Gateway.request_status.code == 4
                    "
                  >
                    <b-form-group
                      id="input-group-10"
                      label="عملیات:"
                      label-for="input-10"
                    >
                      <b-button
                        @click="SendRequestToBank()"
                        :disabled="disabled == 1"
                        >درخواست درگاه از شاپرک</b-button
                      >
                    </b-form-group>
                  </div>
                  <div
                    v-if="
                      Gateway.request_status && Gateway.request_status.code == 5
                    "
                  >
                    <b-form-group
                      id="input-group-10"
                      label="عملیات:"
                      label-for="input-10"
                    >
                      <b-button disabled
                        >لطفا منتظر پاسخ ایمیل بمانید و در صورت دریافت نام
                        کاربری و رمز عبور، آن را وارد نموده و درگاه را تایید
                        نمایید</b-button
                      >
                    </b-form-group>
                  </div>
                  <div
                    v-if="
                      Gateway.mdid20_request_status &&
                      Gateway.mdid20_request_status == 1981
                    "
                  >
                    <b-form-group
                      id="input-group-10"
                      label="عملیات:"
                      label-for="input-10"
                    >
                      <b-button
                        @click="ResetGateway()"
                        :disabled="disabled == 1"
                        >ریست درگاه</b-button
                      >
                    </b-form-group>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              v-if="
                Gateway.mdid12_money_type == 483 ||
                Gateway.mdid12_money_type == 484
              "
            >
              <b-col cols="12" md="3" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="ترمینال:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.terminal"
                    placeholder="ترمینال"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="کد پذیرنده:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.acceptor_code"
                    placeholder="کد پذیرنده"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="نام کاربری:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.username"
                    placeholder="نام کاربری"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3" sm="6">
                <b-form-group
                  id="input-group-2"
                  label="رمز عبور:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="Gateway.password"
                    placeholder="رمز عبور"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="3" sm="6">
                <b-form-group
                  id="input-group-8"
                  label="وضعیت:"
                  label-for="input-8"
                >
                  <MDDropdown
                    v-bind:group="19"
                    v-model="Gateway.mdid19_status"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3" sm="6">
                <b-form-group
                  id="input-group-8"
                  label="انتخاب عملیات:"
                  label-for="input-8"
                >
                  <b-form-select
                    v-model="statusAction"
                    :options="options"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" sm="6">
                <b-form-group
                  id="input-group-8"
                  label="عنوان توضیحات:"
                  label-for="input-8"
                >
                  <MDDropdown
                    v-if="Gateway.mdid12_money_type == 483"
                    v-model="Gateway.mdid117_description"
                    v-bind:group="117"
                  ></MDDropdown>
                  <MDDropdown
                    v-if="Gateway.mdid12_money_type == 1722"
                    v-model="Gateway.mdid117_description"
                    v-bind:group="118"
                  ></MDDropdown>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" sm="6">
                <b-form-group
                  id="input-group-8"
                  label="خلاصه توضیحات:"
                  label-for="input-8"
                >
                  <b-form-textarea
                    v-model="Gateway.summary"
                    id="textarea"
                    placeholder="توضیحات خود را وارد کنید..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" sm="4">
                <b-button
                  block
                  class="mt-2"
                  variant="success"
                  @click="Save()"
                  :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
                  >ذخیره</b-button
                >
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-button
                  block
                  class="mt-2"
                  variant="warning"
                  @click="HandleRequest()"
                  :class="
                    isBusyAgain ? 'spinner spinner-light spinner-right' : ''
                  "
                  >انجام عملیات شاپرک</b-button
                >
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-button
                  block
                  variant="success"
                  @click="clearMerchantCache()"
                  class="mt-2"
                  >خالی کردن cache درگاه</b-button
                >
              </b-col>
              <b-col cols="12" md="4" sm="4">
                <b-button
                  block
                  variant="danger"
                  @click="backToMerchants()"
                  class="mt-2"
                  >بازگشت</b-button
                >
              </b-col>
            </b-row>
            <b-modal id="modal_Show_responce" title="اخطار">{{
              message
            }}</b-modal>
          </div>
        </b-tab>
        <b-tab title="درگاه های متصل" href="#gateway_acceptors">
          <gatewayacceptors></gatewayacceptors>
        </b-tab>
        <b-tab
          title="مشخصات مشتری"
          href="#customerDetail"
          @click="getUserData()"
        >
          <b-card-text>
            <b-row>
              <b-col cols="4">
                <b-form-group
                  id="example-input-group-1"
                  label="نوع:"
                  label-for="example-input-1"
                >
                  <MDDropdown
                    :disabled="false"
                    v-bind:group="17"
                    v-model="user.mdid17_merchant_type"
                  ></MDDropdown>
                  <b-form-invalid-feedback id="input-1-live-feedback"
                    >وارد کردن نام اجباری است</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <div v-if="user.mdid17_merchant_type == 1550">
              <PersonInfo
                v-model="user"
                v-bind:disabled="false"
                v-bind:readonly="Gateway.mdid20_request_status != 1634"
              ></PersonInfo>
            </div>
            <div v-if="user.mdid17_merchant_type == 1551">
              <CompanyInfo
                v-model="user"
                v-bind:disabled="false"
                v-bind:readonly="Gateway.mdid20_request_status != 1634"
              ></CompanyInfo>
            </div>
            <h4>اطلاعات تماس</h4>
            <UserAddress v-model="user" v-bind:disabled="false"></UserAddress>
            <div>
              <b-button @click="SaveUser" variant="success">ذخیره</b-button>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title="وضعیت تاییدها" href="#confDetail" @click="getConfData()">
          <b-card-text>
            <list-table
              :url="userconf.url"
              title="وضعیت تاییدیه ها"
              :detailUrl="userconf.detailUrl"
              :fields="userconf.fields"
              :params="userconf.params"
            ></list-table>
          </b-card-text>
        </b-tab>
        <b-tab
          title="تراکنش ها"
          href="#transactionDetail"
          @click="getTransactionData()"
        >
          <b-card-text>
            <list-table
              :url="transactions.url"
              title="لیست تراکنش ها"
              :fields="transactions.fields"
              :params="transactions.params"
              :detailCallFun="transactions.detailCallFun"
              :detailCallFunType="transactions.detailCallFunType"
              @handle_function_call="ShowDetail"
            ></list-table>
          </b-card-text>
        </b-tab>
        <b-tab
          title="شباهای شرکای تجاری"
          href="#paymentGatewayIbns"
          @click="getPaymentGatewayIbnsData()"
        >
          <b-card-text>
            <list-table
              :url="paymentgatewayibns.url"
              title="لیست شباها"
              :fields="paymentgatewayibns.fields"
              :params="paymentgatewayibns.params"
              :detailCallFun="paymentgatewayibns.detailCallFun"
              :detailCallFunType="paymentgatewayibns.detailCallFunType"
            ></list-table>
          </b-card-text>
        </b-tab>
        <b-tab
          title="شبای تسویه"
          href="#settelmentsheba"
          @click="getshebadata()"
        >
          <b-card title="تایید شماره شبا">
            <b-alert variant="danger" :show="errors.length > 0">
              <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
            </b-alert>
            <div class="row">
              <div class="col-md-4">
                <h3>اطلاعات مالک</h3>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group label="نام و نام خانوادگی:">
                      <div class="form-control">
                        {{ userCard.user.name }}
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <b-form-group label="کد ملی:">
                      <div class="form-control">
                        {{ userCard.user.national_card_number }}
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-12" v-if="userCard.bank_name != null">
                    <b-img
                      fluid
                      :src="
                        routesMap.BankImage +
                        userCard.bank_name.latin_code +
                        '-300-c.png'
                      "
                    ></b-img>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <h3>اطلاعات حساب</h3>
                <div class="row">
                  <div class="col-md-12">
                    <!-- <h4>{{ userCard.shaba_number }}</h4> -->
                    <b-form-group label="شماره شبا:">
                      <!-- {{ userCard.nickname }} -->
                      <b-form-input
                        id="input-7"
                        v-model="userCard.shaba_number"
                        required
                        placeholder="شماره شبا"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label="نام مالک حساب:">
                      <!-- {{ userCard.nickname }} -->
                      <b-form-input
                        id="input-7"
                        v-model="userCard.nickname"
                        required
                        placeholder="نام مالک حساب"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label="شماره حساب:">
                      <!-- {{ userCard.nickname }} -->
                      <b-form-input
                        id="input-7"
                        v-model="userCard.account_number"
                        required
                        placeholder="شماره حساب"
                      ></b-form-input>
                    </b-form-group>
                    <b-row>
                      <b-col class="pt-2 px-2" cols="12" lg="2" md="4" sm="4">
                        <b-button
                          block
                          ref="estelam1"
                          variant="info"
                          @click="estelam"
                          >استعلام</b-button
                        >
                      </b-col>
                      <b-col class="pt-2 px-2" cols="12" lg="2" md="4" sm="4">
                        <b-button
                          block
                          variant="success"
                          @click="editConfirmSheba(1)"
                          >تایید</b-button
                        >
                      </b-col>
                      <b-col class="pt-2 px-2" cols="12" lg="2" md="4" sm="4">
                        <b-button
                          block
                          variant="danger"
                          @click="editConfirmSheba(2)"
                          >عدم تایید</b-button
                        >
                      </b-col>
                      <b-col class="pt-2 px-2" cols="12" lg="2" md="6" sm="6">
                        <b-button
                          block
                          variant="primary"
                          @click="editConfirmSheba(3)"
                          >ذخیره</b-button
                        >
                      </b-col>
                      <b-col class="pt-2 px-2" cols="12" lg="4" md="6" sm="6">
                        <b-button
                          class=""
                          block
                          variant="secondary"
                          @click="editConfirmSheba(4)"
                          >ارسال به شرکای تجاری</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <div class="col-md-12 pt-5" v-if="estelamResult != null">
                <h3>نتیجه استعلام</h3>
                <b-form-group label="شماره شبا:">
                  <div class="form-control">
                    {{ estelamResult.ibanNumber }}
                  </div>
                </b-form-group>
                <b-form-group label="نام بانک:">
                  <div class="form-control">
                    {{ estelamResult.bank }}
                  </div>
                </b-form-group>
                <b-form-group label="شماره حساب:">
                  <div class="form-control">
                    {{ estelamResult.accountNumber }}
                  </div>
                </b-form-group>
                <b-form-group label="توضیحات حساب:">
                  <div class="form-control">
                    {{ estelamResult.accountStatus }}
                  </div>
                </b-form-group>
                <b-form-group label="مالکان:">
                  <div class="form-control">
                    {{ estelamResult.ownerName}}
                  </div>
                </b-form-group>
              </div>
            </div>
          </b-card>
        </b-tab>
        <b-tab
          title="وضعیت درخواست درگاه"
          href="#requestGatewayStatus"
          @click="getRequestGatewayData()"
        >
          <b-card-text>
            <list-table
              :url="requestgateway.url"
              title="لیست درخواست ها"
              :fields="requestgateway.fields"
              :params="requestgateway.params"
              :detailCallFun="requestgateway.detailCallFun"
              :detailCallFunType="requestgateway.detailCallFunType"
              :btns="requestgateway.btns"
              @handle_function_call="SendRequestRead"
            >
            </list-table>
          </b-card-text>
        </b-tab>
        <b-tab
          title="تغییرات درگاه"
          href="#requestGatewayChanges"
          @click="getRequestGatewayDataChanges()"
        >
          <b-card-text>
            <list-table
              :url="requestgatewayChanges.url"
              title="نمایش تغییرات درگاه"
              :fields="requestgatewayChanges.fields"
              :params="params"
            >
            </list-table>
          </b-card-text>
        </b-tab>
        <b-tab href="#userticket" title="تیکت ها">
          <b-card-text>
            <list-table
              :url="tickets.url"
              :newUrl="tickets.newUrl"
              title="لیست تیکت ها"
              :detailUrl="tickets.detailUrl"
              :fields="tickets.fields"
              :params="tickets.params"
            ></list-table>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal id="transaction-details" hide-footer>
      <template v-slot:modal-title>اطلاعات تراکنش</template>
      <div class="d-block">
        <b-form-group label="وضعیت:">
          <div class="form-control">
            {{ trDetail.is_verify == 1 ? "تایید شده" : "تایید نشده" }}
          </div>
        </b-form-group>
        <b-form-group label="مبلغ:">
          <div class="form-control">
            {{ Number(trDetail.cost).toLocaleString() }}
          </div>
        </b-form-group>
        <b-form-group label="تاریخ:">
          <div class="form-control">{{ trDetail.persian_date }}</div>
        </b-form-group>
        <b-form-group label="ساعت:">
          <div class="form-control">
            {{
              new Date(trDetail.verify_date).getHours() +
              ":" +
              new Date(trDetail.verify_date).getMinutes()
            }}
          </div>
        </b-form-group>
        <b-form-group label="آدرس درخواست دهنده:">
          <div class="form-control">
            <b-img
              :src="
                'media/svg/flags/' +
                trDetail.location.countryCode.toLowerCase() +
                '.svg'
              "
              height="20px"
            ></b-img>
            {{ trDetail.ip }}
          </div>
        </b-form-group>
        <b-form-group label="کد رهگیری پرداخت:">
          <div class="form-control">{{ trDetail.sale_reference_id }}</div>
        </b-form-group>
        <b-form-group label="شماره کارت:">
          <div class="form-control sc-card-pan">
            {{ trDetail.card_holder_pan }}
          </div>
        </b-form-group>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('transaction-details')"
        >بستن</b-button
      >
    </b-modal>

    <b-modal
      id="modal-tax-inquiry"
      title="پاسخ استعلام کد رهگیری"
      ok-title="تایید"
      cancel-title="انصراف"
    >
      <p class="my-4">{{ tax_error }}</p>
    </b-modal>
    <b-modal
      id="modal-request-gateway-inquiry"
      title="پاسخ استعلام درگاه"
      ok-title="تایید"
      cancel-title="انصراف"
    >
      <p class="my-4">{{ request_gateway_error }}</p>
      <div v-if="requestRejectionReasons.length > 0">
        <div v-for="x in requestRejectionReasons" v-bind:key="x">
          <b-row>
            <b-col><b>فیلد:</b> {{ x.fieldName }}</b-col>
            <b-col
              ><b>کد خطا: </b>{{ x.codeExceptionValue }} ({{
                GetCodeExceptionValueText(x.codeExceptionValue)
              }})</b-col
            >
          </b-row>
        </div>
      </div>
    </b-modal>
    <b-modal id="json-details" hide-footer>
      <template v-slot:modal-title>اطلاعات Json</template>
      <div>
        {{ JSON.parse(jsonDetails) }}
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('json-details')"
        >بستن</b-button
      >
    </b-modal>
  </div>
</template>
<style>
.custom-control.custom-checkbox {
  margin-top: 30px;
}
.sc-card-pan {
  direction: ltr;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { REQUEST_HANDLE } from "@/core/services/store/requestHandler.module";
import httpHelper from "../../helpers/httpHelper";
import routesMap from "@/helpers/routesMap";
import MDDropdown from "../../components/MDDropdown";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
import PersonInfo from "../Users/PersonInfo";
import CompanyInfo from "../Users/CompanyInfo";
import UserAddress from "../Users/UserAddress";
import gatewayacceptors from "./gatewayacceptors.vue";
import moment from "jalali-moment";
export default {
  name: "EditGateway",
  data() {
    return {
      optionsConnect: [
        { text: "مستقیم", value: 1 },
        { text: "واسط", value: 0 },
      ],
      jsonDetails: null,
      window: {
        width: 0,
        height: 0,
      },
      requestRejectionReasons: [],
      isBusy: false,
      isBusyAgain: false,
      statusAction: null,
      options: [
        {
          text: "درخواست مجدد درگاه از شاپرک",
          value: "shaparak/v2/requestTerminalFromShaparak/",
        },
        {
          text: "درخواست فعالسازی درگاه",
          value: "shaparak/v2/activatemerchant/",
        },
        {
          text: "درخواست مجدد درگاه از PSP",
          value: "shaparak/v2/requestTerminalFromBank/",
        },
        {
          text: "درخواست بروزرسانی حساب از شاپرک",
          value: "shaparak/v2/updateIBAN/",
        },
        {
          text: "درخواست ویرایش اطلاعات پذیرنده از شاپرک",
          value: "shaparak/v2/updatemerchant/",
        },
      ],
      optionsSummary: [],
      optionsIban: [],
      userCard: {
        user: {},
      },
      userCardSend: {},
      estelamResult: null,
      trDetail: { location: { countryCode: "IR" } },
      Gateway: {
        id: 0,
        request_status: {},
        taxpayercode: null,
        is_direct: 1,
      },
      message: "",
      errors: [],
      success_errors: [],
      disabled: 0,
      user_info: [],
      fix_price: "accepted",
      percent_price: "accepted",
      user: {},
      tax_error: "",
      request_gateway_error: "",
      userconf: {
        url: "",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "type.title",
            label: "برای",
          },
          {
            key: "status.title",
            label: "وضعیت",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [],
        detailUrl: "editUserConf",
      },
      transactions: {
        url: "",
        detailCallFunType: "id",
        detailCallFun: "ShowDetail",
        fields: [
          {
            key: "id",
            label: "شماره تراکنش",
          },
          {
            key: "is_verify",
            label: "وضعیت",
            formatter: (value, key, item) => {
              return value ? "پرداخت شده" : "پرداخت نشده";
            },
            tdClass: (value, key, item) => {
              return value ? "text-success" : "text-danger";
            },
          },
          {
            key: "sale_reference_id",
            label: "کد رهگیری",
          },
          {
            key: "cost",
            label: "مبلغ",
          },
          {
            key: "card_holder_pan",
            label: "شماره کارت",
            tdClass: "sc-card-pan",
          },
          {
            key: "title",
            label: "نام بانک",
          },
          {
            key: "verify_date",
            label: "تاریخ و ساعت تایید",
            formatter: (value, key, item) => {
              return value != null
                ? persianDate.getDateByFormat(value) +
                    " - " +
                    new Date(value).getHours() +
                    ":" +
                    new Date(value).getMinutes()
                : "-";
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "از تاریخ",
            field: "dateFrom",
            type: "date-picker",
          },
          {
            label: "تا تاریخ",
            field: "dateTo",
            type: "date-picker",
          },
          {
            label: "کد رهگیری پرداخت",
            field: "saleOrderId",
            type: "text",
          },
          {
            label: "چهار رقم آخر کارت",
            field: "cardNumber",
            type: "text",
          },
        ],
      },
      paymentgatewayibns: {
        url: "",
        fields: [
          {
            key: "id",
            label: "شناسه",
          },

          {
            key: "user_card.nickname",
            label: "نام",
          },
          {
            key: "user_card.shaba_number",
            label: "شماره شبا",
          },
          {
            key: "user_card.account_number",
            label: "شماره حساب",
          },
        ],
        params: [
          {
            label: "نام ",
            field: "nickname",
            type: "text",
          },
          {
            label: "شماره شبا",
            field: "shaba_number",
            type: "text",
          },
        ],
      },
      requestgateway: {
        detailCallFunType: "id",
        detailCallFun: "SendRequestRead",
        url: "",
        fields: [
          {
            key: "id",
            label: "شناسه",
          },
          {
            key: "created_at",
            label: "تاریخ درخواست",
            formatter: (value, key, item) => {
              return (
                persianDate.getDateByFormat(value) +
                " " +
                new Date(value).getHours() +
                ":" +
                new Date(value).getMinutes()
              );
            },
          },
          {
            key: "trackingNumber",
            label: "شماره رهگیری",
          },
          {
            key: "trackingNumberPsp",
            label: "شماره رهگیری psp",
          },
          {
            key: "company_name",
            label: "ارسال به",
            formatter: (value, key, item) => {
              switch (value) {
                case "shaparak":
                  return "شاپرک";
                  break;
                case "Behpardakht":
                  return "به پرداخت";
                  break;
                default:
                  return "-";
                // code block
              }
            },
          },
          {
            key: "type_request",
            label: "نوع درخواست",
            formatter: (value, key, item) => {
              switch (value) {
                case "CreateCustomer":
                  return "تعریف مشتری";
                  break;
                case "RequestBTerminal":
                  return "درخواست ترمینال به پرداخت";
                  break;
                case "RequestSTermina":
                  return "درخواست ترمینال به شاپرک";
                  break;
                case "Read":
                  return "خواندن";
                  break;
                default:
                  return "-";
              }
            },
          },
          {
            key: "btns",
            label: "نمایش json",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        btns: [
          {
            icon: "eye",
            title: "نمایش json",
            handler: (t) => {
              this.jsonDetails = t.send_data;
              this.$bvModal.show("json-details");
            },
          },
        ],
        params: [],
      },
      requestgatewayChanges: {
        url: "",
        fields: [
          {
            key: "from",
            label: "از",
          },
          {
            key: "to",
            label: "به",
          },
          {
            key: "type",
            label: "نوع",
          },
          {
            key: "date",
            label: "تاریخ",
            // formatter: (value, key, item) => {
            //   return persianDate.getDate(value);
            // },
          },
        ],
      },
      turnovers: {
        url: "GardeshHesab?user_id=" + this.$route.params.id,
        detailCallFun: "ShowDetail",
        detailCallFunType: "transaction_id",

        fields: [
          {
            label: "کد تراکنش",
            key: "transaction_id",
            formatter: (value, key, item) => {
              return value == null ? item.doc_id : value;
            },
          },
          {
            label: "عنوان تراکنش",
            key: "des",
            formatter: (value, key, item) => {
              return item.doc_id <= 0
                ? "تراکنش ناموفق"
                : item.ttalWithoutKarmozd >= 0
                ? "واریز"
                : "برداشت";
            },
          },
          {
            label: "تاریخ",
            key: "created_at",
            formatter: (value, key, item) => {
              var d = new Date(value);
              return (
                persianDate.getDateByFormat(value) +
                " " +
                d.getHours() +
                ":" +
                d.getMinutes()
              );
            },
          },
          {
            label: "مبلغ با احتساب کارمزد",
            key: "ttalWithoutKarmozd",
            formatter: (value, key, item) => {
              ///var mezrab = item.bes - item.bed > 0 ? 1 : -1;
              //return Number(mezrab * (item.bes - item.bed)).toLocaleString();
              return Number(value).toLocaleString();
            },
            tdClass: (value, key, item) => {
              return item.doc_id <= 0
                ? "text-warning"
                : item.ttalWithoutKarmozd > 0
                ? "text-success"
                : "text-danger";
            },
          },
          {
            label: "کارمزد",
            key: "karmozd",
            formatter: (value, key, item) => {
              return Number(value).toLocaleString();
            },
          },
          {
            label: "موجودی",
            key: "Total",
            formatter: (value, key, item) => {
              return item.doc_id <= 0
                ? "-----"
                : Number(value).toLocaleString();
            },
          },
          {
            label: "جزییات",
            key: "details",
          },
        ],
        params: [
          {
            label: "درگاه ها",
            field: "api",
            type: "select",
            options: [],
          },
        ],
      },
      tickets: {
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "subject",
            label: "عنوان",
          },
          {
            key: "ticket_periority.title",
            label: "اهمیت",
          },
          {
            key: "created_at",
            label: "تاریخ",
            formatter: (value, key, item) => {
              return persianDate.getDate(value);
            },
          },
          {
            key: "ticket_status.title",
            label: "وضعیت",
          },
          {
            key: "ticket_departments.name",
            label: "دپارتمان",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "عنوان",
            field: "subject",
            type: "text",
          },
          {
            label: "شناسه تیکت",
            field: "id_t",
            type: "text",
          },
          {
            label: "از تاریخ",
            field: "start_date",
            type: "date-picker",
          },
          {
            label: "تا تاریخ",
            field: "end_date",
            type: "date-picker",
          },
          {
            label: "دپارتمان",
            field: "department_id",
            type: "select",
            options: [],
          },
          {
            label: "وضعیت",
            field: "mdid1_status",
            type: "mddropdown",
            group: 1,
          },
        ],
        detailUrl: "ticketDetails",
      },
      params: [],
      routesMap,
    };
  },
  components: {
    gatewayacceptors,
    MDDropdown,
    "list-table": TableShowData,
    PersonInfo,
    CompanyInfo,
    UserAddress,
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ShowDetail(item, type) {
      url = "";
      if (type == "id" && item.id != null) {
        var url = "transactions?id=" + item.id;
      }
      if (type == "transaction_id" && item.transaction_id != null) {
        var url = "transactions?id=" + item.transaction_id;
      }

      if (url != "") {
        httpHelper.getData(url).then((res) => {
          this.trDetail = res.result;
          this.$bvModal.show("transaction-details");
        });
      }
    },
    SendRequestRead(item, type) {
      this.request_gateway_error = "";
      switch (item.company_name) {
        case "shaparak":
          if (item.trackingNumber != "" && item.trackingNumber != null) {
            httpHelper
              .getData("shaparak/Read/" + item.trackingNumber)
              .then((res) => {
                if (res.success && res.result !== null) {
                  switch (res.result[0].status) {
                    case 5:
                      {
                        this.request_gateway_error =
                          "درخواست ثبت درگاه در شاپرک رد شده است";
                        this.requestRejectionReasons = [];
                        res.result[0].requestRejectionReasons.forEach(
                          (element) => {
                            this.requestRejectionReasons.push(element);
                          }
                        );
                      }
                      break;
                    case 8:
                      this.request_gateway_error =
                        "سرورس در شاپرک ثبت شده و در حال تایید می باشد";
                      break;
                    case 12:
                      this.request_gateway_error =
                        "سرورس در حال پردازش توسظ شاپرک می باشد";
                      break;
                    case 14:
                      this.request_gateway_error =
                        "سرورس تایید شده و قابل استفاده می باشد";
                      break;
                    case 20:
                      this.request_gateway_error =
                        " در پروسه بررسی و تایید داخلی شاپرک";
                      break;
                    default:
                      this.request_gateway_error = "خطای نامشخص";
                      break;
                  }
                }
                this.$bvModal.show("modal-request-gateway-inquiry");
              });
          } else {
            this.request_gateway_error =
              "کد رهگیری برای این درخواست موجود نمی باشد";
            this.$bvModal.show("modal-request-gateway-inquiry");
          }
          break;
        case "Behpardakht":
          if (item.trackingNumberPsp != "" && item.trackingNumberPsp != null) {
            httpHelper
              .getData("behpardakht/Read/" + item.trackingNumberPsp)
              .then((res) => {
                if (res.success && res.result !== null) {
                  this.request_gateway_error = res.result;
                }
                this.$bvModal.show("modal-request-gateway-inquiry");
              });
          } else {
            this.request_gateway_error =
              "کد رهگیری برای این درخواست موجود نمی باشد";
            this.$bvModal.show("modal-request-gateway-inquiry");
          }
          break;
        default:
          this.request_gateway_error =
            "به دلیل مشخص نبودن نام شرکت ، مجاز به ارسال درخواست نمی باشید";
          this.$bvModal.show("modal-request-gateway-inquiry");
      }
    },
    SendRequestToBank() {
      this.errors = [];
      this.success_errors = [];
      this.disabled = 1;
      httpHelper
        .postData("MerchantRequest", {
          id: this.Gateway.id,
          state: this.Gateway.request_status.code,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.LoadData();
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
          this.disabled = 0;
        });
      this.LoadData();
    },
    ResetGateway() {
      this.errors = [];
      this.success_errors = [];
      this.disabled = 1;
      httpHelper
        .postData("reset_gateway", {
          gateway_id: this.Gateway.id,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.LoadData();
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
          this.disabled = 0;
        });
      this.LoadData();
    },
    SaveUser() {
      this.errors = [];
      httpHelper.postData("users", this.user).then((res) => {
        if (res.success) {
          this.$makeToast(
            "success",
            "ذخیره موفق",
            "اطلاعات با موفقیت ذخیره گردید.",
            5000
          );
        } else {
          this.errors.push(res.error[0]);
        }
      });
    },
    getUserData() {
      httpHelper.getData("users?id=" + this.user_info.id).then((res) => {
        this.user = res.result;
      });
    },
    getConfData() {
      this.userconf.url = "userconf?user_id=" + this.user_info.id;
    },

    getTransactionData() {
      this.transactions.url =
        "transactions?user_id=" +
        this.user_info.id +
        "&payment_gateways_id=" +
        this.Gateway.id;
    },
    getPaymentGatewayIbnsData() {
      this.paymentgatewayibns.url =
        "paymentgatewayibns" + "?gateway_id=" + this.$route.params.id;
    },
    getRequestGatewayData() {
      this.requestgateway.url =
        "MerchantRequest" + "?payment_gateway_id=" + this.$route.params.id;
    },
    getRequestGatewayDataChanges() {
      this.requestgatewayChanges.url = `payment-gateway-log/${this.$route.params.id}`;
    },
    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 50);
      }, 20);
    },
    scrollListener: function (e) {
      this.visible = window.scrollY > 150;
    },
    Save() {
      this.success_errors = [];
      this.errors = [];
      this.isBusy = true;
      httpHelper.postData("paymentgateways", this.Gateway).then((res) => {
        this.isBusy = false;
        this.scrollTop();
        if (res.success && res.result !== null) {
          this.success_errors.push("عملیات با موفقیت انجام شد");
        } else {
          if (res.error) {
            for (var key in res.error) {
              this.errors.push(res.error[key]);
            }
          }
        }
        this.LoadData();
      });
    },
    TaxInquiry() {
      this.tax_error = "";

      httpHelper
        .postData("paymentgateways/taxinquiry", { gateway_id: this.Gateway.id })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.tax_error =
              "کد رهگیری " +
              res.result.followCode +
              " از طرف اداره مالیات صحیح و تایید شده می باشد";
            this.Gateway.taxpayercode = res.result.followCode;
          } else {
            if (Array.isArray(res.error)) {
              this.tax_error = res.error[0];
            } else {
              this.tax_error = res.error;
            }
          }

          this.$bvModal.show("modal-tax-inquiry");
        });
    },
    TaxRegister() {
      this.tax_error = "";
      httpHelper
        .postData("paymentgateways/taxregister", {
          gateway_id: this.Gateway.id,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.tax_error =
              "کد رهگیری " +
              res.result.followCode +
              " از طرف اداره مالیات صحیح و تایید شده می باشد";
            this.Gateway.taxpayercode = res.result.followCode;
          } else {
            if (Array.isArray(res.error)) {
              this.tax_error = res.error[0];
            } else {
              this.tax_error = res.error;
            }
          }

          this.$bvModal.show("modal-tax-inquiry");
        });
    },
    estelam() {
      this.errors = [];
      this.$refs["estelam1"].classList.add(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      httpHelper
        .getData("sharing/get-iban-info/Saderat/" + this.userCard.shaba_number)
        .then((res) => {
          if (res.success == true) {
            this.estelamResult = res.result;
            this.$refs["estelam1"].classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
          } else {
            this.estelamResult = {};
            this.errors.push(res.error.message);
          }
        });
    },
    editConfirmSheba(state) {
      this.userCardSend = {};
      this.userCardSend.id = this.userCard.id;
      this.userCardSend.sheba_number = this.userCard.shaba_number;

      if (state == 1) {
        this.userCardSend.mdid8_status = 1571;
      }
      if (state == 2) {
        this.userCardSend.mdid8_status = 1572;
      }
      if (state == 3) {
        this.userCardSend.nickname = this.estelamResult.ownerName;
        this.userCardSend.account_number = this.estelamResult.accountNumber;
      }
      if (state == 4) {
        this.userCardSend.is_business_partners = 1;
      }
      httpHelper
        .postData("confirmedshebacard", this.userCardSend)
        .then((res) => {
          if (res.success) {
            this.estelamResult = null;
            this.getshebadata();
            this.$makeToast(
              "success",
              "ذخیره موفق",
              "اطلاعات با موفقیت ذخیره گردید.",
              5000
            );
          }
        });
    },
    getshebadata() {
      httpHelper
        .getData("usercards?id=" + this.Gateway.user_card_id)
        .then((res) => {
          this.userCard = res.result;
        });
    },
    GetResult() {
      this.disabled = 1;
      this.errors = [];
      this.success_errors = [];
      httpHelper
        .postData("MerchantRequest", {
          id: this.Gateway.id,
          state: 1,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.LoadData();
            if (res.result.status == 12) {
              this.errors.push(
                "این درگاه در صف بررسی می باشد لطفا بعدا مجددا تلاش نمایید"
              );
              this.scrollTop();
            } else {
              this.success_errors.push("عملیات با موفقیت انجام شد");
            }
          } else {
            if (res.error.errors && res.error.errors.length > 0) {
              for (var key in res.error.errors) {
                this.errors.push(res.error.errors[key]);
              }
              this.scrollTop();
            }
          }
          this.disabled = 0;
        });
      this.LoadData();

      // httpHelper
      //   .getData("MerchantRequest/" + this.Gateway.last_trackingNumber)
      //   .then((res) => {
      //     if (res.success) {
      //       var result = res.result;
      //       if (result.status == 14) {
      //         this.message =
      //           "عملیات با موفقیت انجام شده است، می توانید وضعیت درخواست را تغییر دهید";
      //       } else if (result.status == 8) {
      //         this.message = "در انتظار تایید توسط شاپرک";
      //       } else {
      //         this.message =
      //           "عملیات با موفقیت انجام نشد، با supper admin تماس بگیرید";
      //       }
      //       this.$bvModal.show("modal_Show_responce");
      //     }
      //   });
    },
    LoadData() {
      httpHelper.setAuth();
      httpHelper
        .getData("paymentgateways?id=" + this.$route.params.id)
        .then((res) => {
          if (res.success) {
            var data = res.result;

            this.Gateway = {
              id: data.id,
              pin: data.pin,
              user_id: data.user_id,
              user_card_id: data.user_card_id,
              wallet_id: data.wallet_id,
              mdid9_category: data.mdid9_category,
              mdid12_money_type: data.mdid12_money_type,
              mdid14_direct_gate: data.mdid14_direct_gate,
              mdid20_request_status: data.mdid20_request_status,
              mdid19_status: data.mdid19_status,
              mdid117_description: data.mdid117_description,
              phone_support: data.phone_support,
              callback_url: data.transfer_core_callback_url,
              website: data.website,
              website_en_name: data.website_en_name,
              website_name: data.website_name,
              description: data.description,
              phone_support: data.phone_support,
              last_trackingNumber: data.last_trackingNumber,
              request_status: data.request_status,
              pre_phone: data.pre_phone,
              pourcents_percent: data.pourcents_percent,
              pourcents_percent_max_value: data.pourcents_percent_max_value,
              pourcents_value: data.pourcents_value,
              terminal: data.terminal,
              acceptor_code: data.acceptor_code,
              username: data.username,
              password: data.password,
              mdid104_payment_priority: data.mdid104_payment_priority,
              mdid105_payment_time: data.mdid105_payment_time,
              taxpayercode: data.taxpayercode,
              summary: data.summary,
              min_sharing: data.min_sharing,
              is_direct: data.is_direct,
              enamad_expiration: data.enamad_expiration
                ? moment(data.enamad_expiration).format("jYYYY/jMM/jDD")
                : "",
            };
            this.getUserCard(this.Gateway.user_id);
            this.user_info = data.user;
            this.tickets.url = "tickets?user_id=" + this.user_info.id;
            this.tickets.newUrl =
              "ClientDetails/" + this.user_info.id + "#ticketsend";
            if (data.created_at != null) {
              this.Gateway.created_at = persianDate.getDateByFormat(
                data.created_at
              );
            } else {
              this.Gateway.created_at = "-";
            }
            if (data.mdid119_status_date != null) {
              this.Gateway.mdid119_status_date = persianDate.getDateByFormat(
                data.mdid119_status_date
              );
            } else {
              this.Gateway.mdid119_status_date = "-";
            }
          }
        });
    },
    GetCodeExceptionValueText(code) {
      switch (code) {
        case -1:
          return "خطای ناشناخته";
        case 5:
          return "فیلد اجباری اما پر نشده";
        case 6:
          return "فرمت فیلد اشتباه ارسال شده است";
        case 11:
          return "داده ی تکراری";
        case 12:
          return "اطلاعات شناسایی اشتباه";
        case 13:
          return "خطای سیستمی";
        case 15:
          return "شماره شبا در دیتای ارسالی ثبت نشده است";
        case 16:
          return "MASTER_DETAIL_RELATION";
        case 17:
          return "داده ی اشتباه";
        case 18:
          return "CHILD_RECORD_FOUND";
        case 25:
          return "ERROR_APPLY_SWITCH_RESULT";
        case 29:
          return "تاریخ تولد اشتباه وارد شده است";
        case 30:
          return "شخص فوت کرده است";
        case 31:
          return "مشکل در ارسال پیامک";
        case 35:
          return "تاریخ صدور گواهینامه اشتباه است";
        case 36:
          return "کد ملی اشتباهی";
        case 37:
          return "کاربر لیمیت شده است";
        case 39:
          return "کد پستی اشتباه است";
        case 40:
          return "مشکل در دریافت اطلاعات شماره شبا";
        case 41:
          return "شماره شبا اشتباه است";
        case 43:
          return "طول فیلد مشکل دارد";
        case 44:
          return "اطلاعات در سیستم قدیمی موجود می باشد";
        case 46:
          return "فیلد تکراری";
        case 47:
          return "INVALID_TERMINAL_TYPE_FOR_BUSINESS_TYPE ";
        case 48:
          return "بانک صادر کننده شماره شبا قابل شناسایی نیست";
        case 49:
          return "کاربر وجود ندارد";
        case 51:
          return "پذیرنده ی شماره شبا وجود ندارد";
        case 52:
          return "داده وجود ندارد";
        case 54:
          return "دیتا تغییر نکرده است";
        case 55:
          return "DUPLICATE_OLD_ACCEPTOR";
        case 56:
          return "درخواست اشتباه";
        case 57:
          return "DUPLICATE_REQUEST_FOR_ACCEPTOR";
        case 58:
          return "BAD_DATA_RANGE";
        case 59:
          return "INVALID_SHOP_FOR_ACCEPTOR";
        case 60:
          return "نوع داده اشتباه است";
        case 61:
          return "داده ناسازگار";
        case 62:
          return "کد پستی وارد شده برای این استان اشتباه است";
        case 63:
          return "کد پستی وارد شده برای این شهر اشتباه است";
        case 64:
          return "PARTIAL_DATA";
        case 65:
          return "شماره شبا تغییر نکرده است";
        case 66:
          return "SWITCH_CHANGE_ERROR";
        case 67:
          return "SHAPARAK_ADMINISTRATION_REJECTION";
        case 68:
          return "UNABLE_TO_ACTIVATE_PERMANENTLY_DEACTIVATED_TERM";
        case 69:
          return "UNABLE_TO_MIGRATE_PERMANENTLY_DEACTIVATED_ACCEP";
        case 70:
          return "ITEM_COUNT_LIMIT_REACHED";
        case 1002:
          return "کاربر جزو بلک لیست می باشد";
        case 10000:
          return "درخواست تکراری برای درخواست درگاه";
        case 10001:
          return "REQUEST_INVALID_FOR_RESPONSE";
        case 10002:
          return "REQUEST_NOTFOUND_FOR_RESPONSE";
        case 10003:
          return "ترمینال تکراری";
        case 10004:
          return "ترمینال وجود ندارد";
        case 10005:
          return "ADMIN_REQUEST_REJECTION";
      }
    },
    backToMerchants() {
      this.Gateway.mdid12_money_type == 483
        ? this.$router.push("/merchants")
        : this.$router.push("/dollar-merchants");
    },

    clearMerchantCache() {
      httpHelper
        .getData(
          "~transaction/operation/refreshGatewaybypin/" + this.Gateway.pin
        )
        .then((res) => {
          this.makeToast(
            "success",
            "اخطار",
            "درگاه با موفقیت بروزرسانی شد.",
            5000
          );
        });
    },

    ShowDetail(item, type) {
      url = "";
      if (type == "id" && item.id != null) {
        var url = "transactions?id=" + item.id;
      }
      if (type == "transaction_id" && item.transaction_id != null) {
        var url = "transactions?id=" + item.transaction_id;
      }
      if (url != "") {
        httpHelper.getData(url).then((res) => {
          this.trDetail = res.result;
          this.$bvModal.show("transaction-details");
        });
      }
    },
    HandleRequest() {
      if (this.statusAction !== null) {
        this.isBusyAgain = true;
        this.$store
          .dispatch(REQUEST_HANDLE, this.statusAction + this.$route.params.id)
          .then((data) => {
            this.isBusyAgain = false;
            if (data.success) {
              this.makeToast(
                "success",
                "عملیات موفق",
                "عملیات مورد نظر با موفقیت انجام شد.",
                5000
              );
            } else {
              this.makeToast("warning", "خطا", data.error[0], 5000);
            }
          })
          .catch((e) => {
            this.isBusyAgain = false;
          });
      } else {
        this.makeToast(
          "warning",
          "خطا",
          "عملیات مورد نظر را انتخاب کنید.",
          5000
        );
      }
    },
    makeToast(variant, title, content, timer) {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        autoHideDelay: timer,
        solid: true,
        toaster: "b-toaster-top-center",
      });
    },
    getUserCard(id) {
      httpHelper.getData("usercards?user_id=" + id).then((res) => {
        this.optionsIban = res.result.map((element) => {
          return {
            text: element.nickname + "(" + element.shaba_number + ")",
            value: element.id,
          };
        });
      });
    },
  },
  created() {
    this.LoadData();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست درگاه ها",
        route: "merchants",
      },
      {
        title: "ویرایش درگاه",
      },
    ]);
  },
};
</script>
